export const ROLLER_COASTER_PRIZE = '/roller-coaster-game/tick'
export const ROLLER_COASTER_AUTOCASH_BET = '/roller-coaster-game/autoCashOutBets'
export const ROLLER_COASTER_PUBLIC_BET = '/roller-coaster-game/closedBets'
export const CRYPTO_FUTURE_PRIZE = '/crypto-futures/tick'
export const CRYPTO_FUTURE_AUTOCASH_BET = '/crypto-futures/autoCashOutBets'
export const CRYPTO_FUTURE_PUBLIC_BET = '/crypto-futures/closedBets'
